export const envConfig = {
  api: {
    // baseUrl: 'http://' + window.location.hostname + ':3512/api'
    baseUrl: 'http://cloud-qualita.ddns.com.br:3513/api'
    //baseUrl: 'http://192.168.0.102:4000/api'
  }
}
